import axios from 'axios'
import { API_ADDRESS_LIVE } from 'config'
import { BuildingsStat } from 'state/types'
import { BuildingConfig } from 'config/constants/types'

export const getBuildingsStats = async (): Promise<BuildingsStat[]> => {
  const url = `${API_ADDRESS_LIVE}/admin/buildings/list-buildings`
  const { data } = await axios.get(url)

  return data
}

export const setStatus = async (buildingObjectIds: string[], status: string): Promise<BuildingConfig[]> => {
  const url = `${API_ADDRESS_LIVE}/admin/buildings/status`
  const { data } = await axios.post(url, {
    buildingObjectIds,
    data: status,
  })

  return data
}

export const createBuilding = async (values): Promise<BuildingsStat> => {
  const url = `${API_ADDRESS_LIVE}/admin/buildings/create`
  const { data } = await axios.post(url, {
    ...values,
  })

  return data
}
